module.exports = __webpack_public_path__ + "img/cronico.cfab59cd.png";